import React from 'react'
import { view } from 'react-easy-state'

const Footer = (props) => (
  <div className="page-footer">
    {"" && (props.content || <span>Copyright &copy; Learner Solutions Private Limited</span>)}
  </div>
)

export default view(Footer)
